import React from 'react'
import { SVGIconProps } from '../types'
const SvgMotorcycle = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="m12.96 6.02-2.687-2.687h-2.94v1.334h2.394L11.06 6H3.333A3.3 3.3 0 0 0 0 9.333a3.3 3.3 0 0 0 3.333 3.334C4.973 12.667 6.3 11.54 6.6 10h1.1l1.847-1.847c-.14.36-.214.76-.214 1.18a3.3 3.3 0 0 0 3.334 3.334A3.3 3.3 0 0 0 16 9.333c0-1.766-1.313-3.18-3.04-3.313M5.213 10c-.28.767-1.026 1.333-1.88 1.333-1.086 0-2-.913-2-2s.914-2 2-2c.854 0 1.6.567 1.88 1.334h-1.88V10zm7.454 1.333c-1.107 0-2-.893-2-2s.893-2 2-2 2 .894 2 2c0 1.107-.894 2-2 2"
      />
    </g>
  </svg>
)
export default SvgMotorcycle
